export default {
  name: 'RtBadge',
  render(h) {
    return h(
      'el-badge',
      {
        attrs: this.$attrs,
        props: this.$props,
        on: this.$listener,
        ['class']: 'rt-badge'
      },
      this.$slots.default
    );
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/badge/rtBadge.js